import Typography from "@portal/components/atoms/v2/typography";
import { LanguageSelector } from "@portal/components/atoms/language/LanguageSelector";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import { IStartPageLanguageProps } from "../types";

export const StartPageLanguage = ({
  isPrimaryLanguage,
  primaryLanguageText,
  secondaryLanguageText,
  isIFrame,
  centerId,
}: IStartPageLanguageProps) => {
  const variant = !isPrimaryLanguage ? "DescriptionBold" : "Description";

  return (
    <>
      <div className={`flex mr-1 max-w[45px] ${isIFrame ? "text-headerMenuText" : "text-robotHeaderBackgroundText"}`}>
        <Typography variant={variant}>
          {secondaryLanguageText}
          {!isPrimaryLanguage && <TextLine wide />}
        </Typography>
      </div>
      <div className="flex mt-px">
        <LanguageSelector centerId={centerId} />
      </div>
      <div className={`flex ml-1 ${isIFrame ? "text-headerMenuText" : "text-robotHeaderBackgroundText"}`}>
        <Typography variant={variant}>
          {primaryLanguageText}
          {isPrimaryLanguage && <TextLine />}
        </Typography>
      </div>
    </>
  );
};
